import React from "react";
import { checkArray } from "../../helpers";

const RadioInputCon = (props) => {
  const { items, name, onChange, value, className = "" } = props;
  return (
    <>
      {checkArray(items) &&
        items.map((item, ind) => {
          return (
            <div class="bullet-sec" key={`${item?.value}_${ind}`}>
              <input
                type="radio"
                className={className}
                id={`${item?.value}_${ind}`}
                checked={value == item?.value}
                onClick={() => onChange(`${name}`, item?.value)}
              />
              <label class="round-check" for={`${item?.value}_${ind}`}>
                {item?.label}{" "}
              </label>
            </div>
          );
        })}
    </>
  );
};

export default RadioInputCon;
